export const typeformAirlineProgramme = {
  async validateAirlineProgramme() {
    if (this.currentValue !== 1) return true

    const field = this.wizardForm()?.querySelector(
      '[name="status_match_application[origin_airline_input]"]'
    )
    const input = field?.value?.trim()
    if (!field || !input) return false
    if (this.validatedAirlineProgrammeInput === input) {
      this.syncReviewSummaryFromForm()
      return this.validateMatchedCampaign()
    }

    this.clearFieldError(field)
    field.setAttribute("aria-busy", "true")

    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(this.airlineProgrammeMatchUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": token
        },
        body: JSON.stringify({ origin_airline_input: input })
      })
      const result = await response.json()

      if (field.value.trim() !== input) return false
      if (response.ok && result.ok) {
        this.validatedAirlineProgrammeInput = input
        const canonicalField = this.wizardForm()?.querySelector(
          '[name="status_match_application[origin_airline]"]'
        )
        if (canonicalField) canonicalField.value = result.airline_key || ""
        this.syncReviewSummaryFromForm()
        return this.validateMatchedCampaign()
      }

      this.showFieldError(
        field,
        result.error || this.t("errors.airline_match_unavailable", "We couldn’t verify this program right now. Please try again.")
      )
      return false
    } catch (_error) {
      this.showFieldError(
        field,
        this.t("errors.airline_match_unavailable", "We couldn’t verify this program right now. Please try again.")
      )
      return false
    } finally {
      field.removeAttribute("aria-busy")
    }
  },

  resetAirlineProgrammeMatch() {
    this.validatedAirlineProgrammeInput = null
    const form = this.wizardForm()
    const canonicalField = form?.querySelector('[name="status_match_application[origin_airline]"]')
    const campaignField = form?.querySelector('[name="status_match_application[status_match_campaign_id]"]')
    if (canonicalField) canonicalField.value = ""
    if (campaignField) campaignField.value = ""
  },

  validateMatchedCampaign() {
    const form = this.wizardForm()
    const campaignId = form
      ?.querySelector('[name="status_match_application[status_match_campaign_id]"]')
      ?.value
    if (campaignId) return true

    const tierField = form?.querySelector('[name="status_match_application[origin_tier]"]')
    if (tierField) {
      this.showFieldError(
        tierField,
        this.t("errors.tier_not_eligible", "This status is not eligible for the entered airline or frequent flyer program.")
      )
    }
    return false
  }
}
